import { BaseSelectorOption, MultiSelectorProps } from "@/types";
import { Component } from "react";
import { MultiSelector } from "./MultiSelector";

interface MultiCategorySelectorProps<
  T extends BaseSelectorOption = BaseSelectorOption
> extends MultiSelectorProps<T> {}

export class MultiCategorySelector<
  T extends BaseSelectorOption = BaseSelectorOption
> extends Component<MultiCategorySelectorProps<T>> {
  constructor(props: MultiCategorySelectorProps<T>) {
    super(props);

    this.state = {};
  }

  render() {
    return <MultiSelector {...this.props} hasNewItem={true} />;
  }
}
